import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components"; // Importar todos los componentes
import * as directives from "vuetify/directives";
import { VDateInput } from "vuetify/labs/VDateInput";

export default createVuetify({
  components: {
    ...components,
    VDateInput, // ✅ Aquí lo añadimos manualmente
  },
  directives,
  theme: {
    themes: {
      light: {
        colors: {
          primary: "#4a4d4e",
          onPrimary: "#ffffff",
        },
      },
    },
  },
});
